"use client";
import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppButton = () => {
    const phoneNumber = "919924382499"; // Rakshit Sakariya - WhatsApp Inquiry
    const message = "Hello! I'm interested in your products.";

    const handleClick = () => {
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, "_blank");
    };

    return (
        <div className="whatsapp-button-container">
            <div onClick={handleClick} className="whatsapp-button" title="Chat on WhatsApp">
                <FaWhatsapp />
            </div>
        </div>
    );
};

export default WhatsAppButton;
